import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[facilityApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[facilityApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    async getFacilities({ page = 1, page_size, q, status, customer, ordering, responsible } = {}) {
        const params = {};
        if (page) params.page = page;
        if (page_size) params.page_size = page_size;
        if (q) params.q = q;
        if (status) params.status = status; // ACTIVE | ARCHIVED | INACTIVE
        if (customer != null && String(customer).trim().length) {
            params.customer_id = customer; // фильтр по клиенту
        }
        if (ordering) params.ordering = ordering;
        if (responsible !== undefined && responsible !== null && responsible !== '') {
            params.responsible = responsible;
        }

        try {
            const response = await axiosInstance.get('facilities/', { params });
            return response.data; // { count, results }
        } catch (error) {
            logAndRethrow('GET facilities/', error);
        }

    },

    async getFacility(id) {
        try {
            const response = await axiosInstance.get(`facilities/${id}`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET facilities/${id}/`, error);
        }
    },

    // POST /api/facilities/create/
    async createFacility(data) {
        try {
            const response = await axiosInstance.post('facilities/create/', data);
            return response.data;
        } catch (error) {
            logAndRethrow('POST facilities/create/', error);
        }
    },


    // PUT/PATCH /api/facilities/{id}/
    async updateFacility(id, data, method = 'put') {
        try {
            const url = `facilities/${id}/`;
            const response = method === 'patch'
                ? await axiosInstance.patch(url, data)
                : await axiosInstance.put(url, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`${method.toUpperCase()} facilities/${id}/`, error);
        }
    },

    // Основной путь архивации
    async archiveFacility(id) {
        try {
            const response = await axiosInstance.post(`facilities/${id}/archive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST facilities/${id}/archive/`, error);
        }
    },

    async deleteFacility(id) {
        try {
            const response = await axiosInstance.delete(`facilities/${id}/delete/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE facilities/${id}/delete/`, error);
        }
    },

    // POST /api/facilities/{id}/unarchive/ (разархивация)
    async unarchiveFacility(id) {
        try {
            const response = await axiosInstance.post(`facilities/${id}/unarchive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST facilities/${id}/unarchive/`, error);
        }
    },

    async addressSuggest({ query, count = 5 }) {
        try {
            const response = await axiosInstance.post('facilities/address-suggest/', { query, count });
            return response.data;
        } catch (error) {
            logAndRethrow('POST facilities/address-suggest/', error);
        }
    },
    // GET /api/facilities/{id}/participants/
    async getFacilityParticipants(id) {
        try {
            const response = await axiosInstance.get(`facilities/${id}/participants/`);
            return response.data; // массив участников: { id, customer_id, short_name, role, created_at }
        } catch (error) {
            logAndRethrow(`GET facilities/${id}/participants/`, error);
        }
    },
    // POST /api/facilities/{id}/participants/
    async addFacilityParticipant(id, payload) {
        try {
            const response = await axiosInstance.post(`facilities/${id}/participants/`, payload);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST facilities/${id}/participants/`, error);
        }
    },

    // DELETE /api/facilities/{id}/participants/{link_id}/
    async deleteFacilityParticipant(id, linkId) {
        try {
            const response = await axiosInstance.delete(`facilities/${id}/participants/${linkId}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE facilities/${id}/participants/${linkId}/`, error);
        }
    },
    // Координаты объектов: GET /facilities/coordinates/
    async getFacilitiesCoordinates() {
        try {
            const response = await axiosInstance.get('facilities/coordinates/');
            return response.data; // массив: [{ id, short_name, address, latitude, longitude }, ...]
        } catch (error) {
            logAndRethrow('GET facilities/coordinates/', error);
        }
    }


};
